// extracted by mini-css-extract-plugin
export default {"breadcrumb-bar":"styles_breadcrumb-bar__c8xwW","breadcrumb-list":"styles_breadcrumb-list__vMP17","breadcrumb-item":"styles_breadcrumb-item__+rcy5"};